var exports = {
  "AM": "Popover__Hga2FU",
  "__": "Popover_Content__dxBYg0",
  "DZ": "Heading__Q9jOYk",
  "Yi": "BranchName__z9BTHm",
  "EY": "Text__NB_Ibg",
  "az": "Box__aeitcR",
};

module.exports = exports;
